// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__vqWXs","content":"RecentSearches_content__KiSaz"};